export const isEmpty = (data) => {
    return data === undefined || data === null || data === ''
}